import {Pipe, PipeTransform} from "@angular/core";
import {SelectableAccessoryModel} from "./selectable-accessory.model";

@Pipe({
  name: "selectableAccessoryFilter",
})
export class SelectableAccessoryPipe implements PipeTransform {
  transform(items: SelectableAccessoryModel[], override?: boolean) {
    if (!items) return [];

    return items.filter(it => override || it.selected);
  }
}
